import { withStylePrefix } from '../common/withStylePrefix';
import { topBarTemplate, TopBarComponent } from './TopBar';
import styles from './TopBar.styles.scss';
export const topBarDefinition = {
    baseName: 'top-bar',
    template: topBarTemplate,
    styles: withStylePrefix(styles),
};
export const chameleonTopBar = TopBarComponent.compose(topBarDefinition);
